<div class="reorder-wizzard">
    <div class="reorder-wizzard__inner">

        <shared-list-for-reorder-items (onSelected)="handleSelected($event)" (onDeselected)="handleDeselected($event)"
            [bottomPadding]="bottomPadding" [reorderItems]="reorderItems$ | async" class="reorder-wizzard__items">
        </shared-list-for-reorder-items>

    </div>
</div>